module.exports = __webpack_public_path__ + "img/espa.b9bd7e95.jpg";